import { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import { noop } from 'lodash'
import { Motion, spring } from 'react-motion'
import Hammer from 'hammerjs'
import Tick from './tick'
import { ThemeContext } from '../../../base/ThemeContext'

export default class Background extends Component {
  constructor(props) {
    super(props)
    this._hammerManager = null
    this._addedHammerListeners = false
  }

  _hammertime() {
    if (!this._hammerManager) {
      this._hammerManager = new Hammer.Manager(ReactDOM.findDOMNode(this), {
        recognizers: [[Hammer.Pan, { threshold: 0, direction: Hammer.DIRECTION_HORIZONTAL }]],
      })
    }
    this._addHammerListeners()
  }

  _addHammerListeners() {
    if (!this._addedHammerListeners && this._hammerManager) {
      this._hammerManager.on('panstart', this.handlePanStart)
      this._hammerManager.on('panmove', this.handlePanMove)
      this._hammerManager.on('panend', this.handlePanEnd)
      this._addedHammerListeners = true
    }
  }

  _removeHammerListeners() {
    if (this._addedHammerListeners && this._hammerManager) {
      this._hammerManager.off('panstart')
      this._hammerManager.off('panmove')
      this._hammerManager.off('panend')
      this._addedHammerListeners = false
    }
  }

  _removeHammerManager() {
    this._hammerManager.destroy()
    this._hammerManager = null
  }

  handlePanStart = hammerEvent => {
    this.props.onPanStart(hammerEvent)
  }

  handlePanMove = hammerEvent => {
    this.props.onPanMove(hammerEvent)
  }

  handlePanEnd = hammerEvent => {
    this.props.onPanEnd(hammerEvent)
  }

  componentDidMount() {
    this._hammertime()
  }

  componentDidUpdate() {
    this._hammertime()
  }

  componentWillUnmount() {
    this._removeHammerListeners()
    this._removeHammerManager()
  }

  getTicksContent() {
    const { ticks, offset, width } = this.props
    const colorScheme = this.context
    return ticks.map(function (tick) {
      const { label, key, type, xPos } = tick
      const actualX = offset + xPos
      const color = colorScheme.tertiary
      return (
        <Motion key={`motion-tick-${key}`} defaultStyle={{ x: actualX }} style={{ x: spring(actualX) }}>
          {interpolated => {
            // do a quick visibility check first
            return interpolated.x > 0 && interpolated.x < width ? (
              <Tick label={label} x={interpolated.x} size={type} color={color} />
            ) : null
          }}
        </Motion>
      )
    })
  }

  render() {
    const { width, height, cursor, axisX, axisY } = this.props
    const colorScheme = this.context
    const backgroundStyle = {
      width,
      height,
      cursor,
      backgroundColor: colorScheme.primary,
    }
    const axisStyle = {
      left: axisX,
      top: axisY,
    }
    const ticks = this.getTicksContent()
    return (
      <div className="background" style={backgroundStyle}>
        <div className="axis" style={axisStyle}>
          {ticks}
        </div>
      </div>
    )
  }
}
Background.contextType = ThemeContext
Background.propTypes = {
  cursor: PropTypes.string,
  width: PropTypes.number.isRequired,
  axisX: PropTypes.number.isRequired,
  axisY: PropTypes.number.isRequired,
  ticks: PropTypes.array.isRequired,
  offset: PropTypes.number.isRequired,
  onPanStart: PropTypes.func.isRequired,
  onPanMove: PropTypes.func.isRequired,
  onPanEnd: PropTypes.func.isRequired,
}
Background.defaultProps = {
  width: 0,
  height: 0,
  axisX: 0,
  axisY: 0,
  cursor: 'auto',
  onPanStart: noop,
  onPanMove: noop,
  onPanEnd: noop,
}
